import styled from 'styled-components';
import { spacer12, spacer24 } from '@spotify-internal/encore-foundation';
import { zIndexPopover } from "../../styles";
export default styled.div.withConfig({
  displayName: "PopoverMobile",
  componentId: "sc-1l4s3vp-0"
})(["background:white;bottom:0;left:0;padding:", " ", ";position:fixed;text-align:center;width:100%;z-index:", ";"], spacer12, spacer24, zIndexPopover);